import React from 'react';
import { Typography, Box } from '@kohler-dsm-library/kohler-core';
import styles from '../productFeatureCarousel.module.css';

export default function SwatchGroup({ swatches = [] }) {
  return (
    <Box className={styles.swatchGroup}>
      {swatches.map((sw, index) => (
        <button key={index} className={`${styles.swatchItem}`}>
          <Box className={styles.swatchColor}>
            <img src={sw.image} alt={sw.altText || ''} />
          </Box>

          <Typography size="label-medium-s" className={styles.swatchLabel}>
            {sw.title}
          </Typography>
        </button>
      ))}
    </Box>
  );
}
